/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PeriscopeEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const periscopeEntrypoint: EntryPoint<PeriscopeEntrypointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<PeriscopeEntrypointComponent>(
		/* webpackChunkName: "async-periscope-entrypoint" */ './PeriscopePage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
